import store from '../stores/store';
import axios from 'axios';

import {
  error
} from './alertAction';
import {
  setMobilePanel,
  soundPlay
} from './chatInitAction';
import {
  threadFollow,
  checkFollowedIntegrity
} from './luserAction';
import { getTranslator } from '../../locales';

export const THREADS_ADD = 'threads-add';
export const THREADS_DELETE = 'threads-delete';
export const THREADS_DELETED = 'threads-deleted';
export const THREADS_INIT = 'threads-init';
export const THREADS_MESSAGE_ADD = 'threads-message-add';
export const THREADS_MESSAGE_DELETE = 'threads-message-delete';
export const THREADS_MESSAGE_DELETED = 'threads-message-deleted';
export const THREADS_MESSAGE_IAM_TYPING = 'threads-message-iam-typing';
export const THREADS_MESSAGE_SUBMIT = 'threads-message-submit';
export const THREADS_MESSAGE_USER_TYPING = 'threads-message-user-typing';
export const THREADS_REFRESH = 'threads-refresh';
export const THREADS_SELECT = 'threads-select';
export const THREADS_SELECTED_HIDDEN_MSG = 'threads-selected-hidden-msg';
export const THREADS_SUBMIT = 'threads-submit';
export const THREADS_TOGGLE_ASK_FORM = 'threads-toggle-ask-form'
export const THREADS_TOOLBOXING = 'threads-toggle-question-toolbox';

export function init(payload) {
  return { type: THREADS_INIT, payload };
}

export function refresh(payload) {
  return { type: THREADS_REFRESH, payload };
}

export function toggleAskForm(payload) {
  return { type: THREADS_TOGGLE_ASK_FORM, payload };
}

export function select(thread_id) {

  return dispatch => {
    const t = getTranslator();

    return axios.get(
        store.getState().chat.serverUrl+'/threads/'+thread_id+'?'+(new Date().getTime()),
        { withCredentials: true }
      )
      .then(function(response) {
        dispatch({ type: THREADS_SELECT, thread: response.data });
        dispatch( setMobilePanel('messages') );
      })
      .catch(function(err){
        if (err.response && err.response.status === 401) {
          dispatch(error('NOT_LOGGED_IN'));
        } else {
          dispatch(error(t.t('Sorry, an error occurred.')));
        }
      }
    );
  }
}

export function submit(thread) {
  return { type: THREADS_SUBMIT, payload: thread };
}

export function add(thread) {
  return dispatch => {
    if (thread.author.id === store.getState().luser.id)
    {
      dispatch( soundPlay('message') );
      dispatch( select( thread.id ) );
      dispatch( threadFollow( thread.id ) );
    }
    else {
      dispatch( soundPlay('post') );
    }

    return dispatch({ type: THREADS_ADD, payload: thread });
  };
}

export function messageSubmit(message) {
  return { type: THREADS_MESSAGE_SUBMIT, message };
}

export function message_add(message) {
  return dispatch => {
    if (store.getState().threads.selectedThread !== null
      && message.threadId == store.getState().threads.selectedThread.id){
        dispatch( soundPlay('message') );
    }
    // else if (store.getState().threads.selectedThread !== null
    //    && message.threadId == store.getState().threads.selectedThread.id)
    // {
    //  dispatch( soundPlay('post') );
    // }

    if (message.author.id === store.getState().luser.id
      && store.getState().luser.followedThreadIds.indexOf(parseInt(message.threadId)) == -1){
      dispatch( threadFollow( message.threadId ) );
    }

    return dispatch({ type: THREADS_MESSAGE_ADD, message });
  };
}

export function user_typing(payload){
  let typers = store.getState().threads.typers;
  const index = typers.indexOf(payload.user);
  typers.splice(index, 1);

  if (payload.is_typing === true
    && payload.thread_id && store.getState().threads.selectedThread
    && payload.thread_id == store.getState().threads.selectedThread.id){
      typers.push(payload.user);
  }
  return { type: THREADS_MESSAGE_USER_TYPING, typers };
}

export function iamTyping(payload) {

  let _typing = store.getState().threads.typing;
  if (_typing.timerId){
      clearTimeout(_typing.timerId);
  }

  if (payload.is_typing) {
    return dispatch => {
      // plan to disable the typing status if no activity next 5s
        const timer = setTimeout(() => {
            dispatch({ type: THREADS_MESSAGE_IAM_TYPING, payload: {status: false} })
        }, 5000);

      _typing.status = payload.is_typing;
        _typing.timerId = timer;
        _typing.thread_id = payload.thread_id;
        dispatch({ type: THREADS_MESSAGE_IAM_TYPING, payload: _typing })

    }
  }
  return { type: THREADS_MESSAGE_IAM_TYPING, payload: {status: false} };
}

export function toggleQuestionToolbox(payload){
  return { type: THREADS_TOOLBOXING, payload };
}

export function deleteThread(threadId) {
  const t = getTranslator();

  if (!window.confirm(t.t('Are you sure you want to delete this discussion?'))) {
    threadId = null;
  }
  return { type: THREADS_DELETE, threadId }
}

export function deletedThread(thread_id){
  return dispatch => {
    dispatch({ type: THREADS_DELETED, thread_id });
    dispatch( checkFollowedIntegrity() );
  }
}

export function deleteMessage(messageId) {
  const t = getTranslator();

  if (!window.confirm(t.t('Are you sure you want to delete this message?'))) {
    messageId = null;
  }
  return { type: THREADS_MESSAGE_DELETE, messageId }
}

export function deletedMessage(thread_id, message_id) {
  return { type: THREADS_MESSAGE_DELETED, data: {thread_id, message_id} }
}

export function hiddenMessagesScrollInfo(status=true){
  return { type: THREADS_SELECTED_HIDDEN_MSG, status: status }
}



// WEBPACK FOOTER //
// ./src/redux/actions/threadsAction.jsx